import React, { FC, useContext } from "react";

import { DiscountProgressBarContext } from "../../context";
import { BreakpointProps } from "../types";

import { CompletedBreakpoint2 } from "./CompletedBreakpoint2";
import { CompletedBreakpoint3 } from "./CompletedBreakpoint3";
import { CompletedBreakpoint4 } from "./CompletedBreakpoint4";
import { CompletedBreakpoint5 } from "./CompletedBreakpoint5";

export const CompletedBreakpointBuilder: FC<BreakpointProps> = (props) => {
  const { theme } = useContext(DiscountProgressBarContext);

  switch (theme.breakpoint.completed) {
    case "completedBreakpoint2":
      return <CompletedBreakpoint2 {...props} />;
    case "completedBreakpoint3":
      return <CompletedBreakpoint3 {...props} />;
    case "completedBreakpoint4":
      return <CompletedBreakpoint4 {...props} />;
    case "completedBreakpoint5":
      return <CompletedBreakpoint5 {...props} />;
    default:
      return null;
  }
};
